import React, { useEffect, useState } from "react";
import "./ThankYou.scss";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Cart from "../Cart/Cart";
import Spinner from "../Spinner/Spinner";
import { useLocation } from "react-router";
import nvCookieHelpers from "../../services/cookieService";
import { useHeaderMenu } from "../../contexts/login.context";
import useLoader from "../../contexts/LoaderContext";
import { useTranslation } from "react-i18next";
import DOMPurify from "dompurify";
import { config } from "../../config";
import { useLocalization } from "../../contexts/LocalizationContext";


const isThanks: boolean = true;
const isVerify: boolean = false;

const ThankYou: React.FC = () => {
  const { locale } = useLocalization();
  const { t } = useTranslation();
  const { state } = useLocation();
  let orderData;
  if (state) {
    if (state.orderData) {
      orderData = state.orderData;
    } else if (state?.cartResult) {
      orderData = state.cartResult;
    }
  }
  // const { InvalidateCheckoutSession } = useAuth();
  const [cartData, setCartData] = useState<any>();
  const [shippingInfoName, setshippingInfoName] = useState("");
  const [shippingAddress, setshippingAddress] = useState("");
  const [shippingCountry, setshippingCountry] = useState("");
  const [shippingContact, setshippingContact] = useState("");
  const [shippingAttn, setShippingAttn] = useState("");
  const navigate = useNavigate();
  const [orderEmail, setOrderEmail] = useState(null);
  const [orderNumber, setOrderNumber] = useState(null);
  const [orderTotal, setOrderTotal] = useState("0");
  const { setItemsInCart, setIsThanks } = useHeaderMenu();
  const { isLoading, showLoader, hideLoader } = useLoader();
  const headingWithSymbol = t("nvidiaSI_INREVIEW_GFN_CONTENT_1");
  const paragraphWithLink = t("ORDER_INSTRUCTIONS_SO_2").replace('{0}', config.bcSupportUrl);
  const sanitizedText = DOMPurify.sanitize(paragraphWithLink, {
    ALLOWED_TAGS: ['a'], // Allow anchor tags
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class'], // Allow necessary attributes including target
  });
  const sanitizedSymbol = DOMPurify.sanitize(headingWithSymbol);
  console.log('ORDER DATA', orderData);

  const currentDate = new Date().toLocaleString(locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  });

  const emptyCart = (msg: string) => {
    navigate(`/${locale}/cart/empty`, { state: { msg } });
  }
  useEffect(() => {
    setIsThanks(true);
    if (!orderData) {
      emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (orderData) {
      showLoader();
      setCartData(orderData);
      let subTotal = orderData["pricing"]["formattedOrderTotal"];
      setOrderNumber(orderData["order"]["id"]);
      setOrderEmail(orderData["billingAddress"]["emailAddress"]);
      setOrderTotal(subTotal);
      let infoNameShipping =
        (orderData.shippingAddress?.firstName || "") +
        " " +
        (orderData.shippingAddress?.lastName || "");

      let addressShipping =
        (orderData.shippingAddress?.line1 ? orderData.shippingAddress?.line1 + ', ' : '') +
        (orderData.shippingAddress?.line2 ? orderData.shippingAddress?.line2 + ', ' : '') +
        (orderData.shippingAddress?.city ? orderData.shippingAddress?.city + ', ' : '') +
        (orderData.shippingAddress?.countrySubdivision ? orderData.shippingAddress?.countrySubdivision + ', ' : '') +
        ((locale !== 'en-hk' && locale !== 'en-me') ? orderData.shippingAddress?.postalCode : '');
      setshippingInfoName(infoNameShipping);
      setshippingAddress(addressShipping);
      setshippingCountry(orderData.shippingAddress?.country || "");
      setshippingContact(orderData.shippingAddress?.phoneNumber || "");
      setShippingAttn(orderData.shippingAddress?.attn || "");
      const items = orderData?.cartItems.cartItem.map((cartItem) => ({
        quantity: cartItem.quantity,
        price: {
          basePrice: parseFloat(cartItem.pricing.formattedListPrice.replace('$', '')), // Convert to number
          discount: 0, // Assuming no discount information is present
        },
        productInfo: {
          sku: `sku-${cartItem.product.id}`, // Generate SKU from product ID if no SKU exists
          prodID: cartItem.product.id.toString(),
          productName: cartItem.product.name,
        },
      }));
      const localeFromPath = window.location.pathname.split('/')[1]; // Extract 'en-us'
      const formattedLocale = localeFromPath.replace('-', '_').toLowerCase().replace(/^[a-z]{2}/, match => match.toUpperCase());
      // Extract product IDs
      const productIds = orderData?.cartItems.cartItem.map(item => item.product.id);
      // Join with colon only if multiple IDs exist
      const pids = productIds.length > 1 ? productIds.join(':') : productIds[0].toString();
      const cart = {
        customerID: "",
        orderID: orderData ? orderData['cartId'] : '',
        currencyCode: orderData ? orderData['pricing']['orderTotal']['currency'] : '',
        loginState: nvCookieHelpers.getCookie('isUserLoggedIn') ? 'loggedIn' : 'guest',
        storeLocale: formattedLocale,
        promoCode: "no",
        // paymentMethod: orderData['paymentMethod']['type'],
        saveCardOption: false, // Assuming this is a boolean
        // cardType: orderData['paymentMethod']['type'],
        shippingMethod: orderData ? orderData.shippingMethod?.description : "",
        items: items
      }
      if (typeof window !== "undefined") {
        (window as any).CartOrder = cart;
      }
      console.log((window as any)?.CartOrder);

      if (typeof window !== "undefined" && typeof (window as any)?.OrderOmniProd === "function") {
        (window as any)?.OrderOmniProd(this, 'event10,purchase', 'checkout:order:', 'success', pids);
      } else {
        console.error("OrderOmniProd function is not available.");
        (window as any)?.OrderOmniProd(this, 'event10', 'checkout:order:', 'failed', pids) // Please pass product ID.
      }
      hideLoader();
    } else {
      emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
    }
    setItemsInCart(0);
    sessionStorage.removeItem("type");
    sessionStorage.removeItem("guest");
    sessionStorage.removeItem("customer");
    sessionStorage.removeItem("loggedIn");
    sessionStorage.removeItem("payment");   
    nvCookieHelpers.deleteCookie("checkout");
    sessionStorage.removeItem("checkoutClicked");
    nvCookieHelpers.deleteCookie("sessionDetails");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData]);

  const returnStore = () => {
    let decodedURL = locale === 'en-hk' ? 'https://www.nvidia.cn/geforce/' : (locale === 'en-ph' || locale === 'fi-fi' || locale === 'da=dk') ? `https://marketplace.nvidia.com/${locale}/consumer/` : `https://marketplace.nvidia.com/${locale === 'en-me' ? 'en-eu' : locale}`;
    if (decodedURL && decodedURL !== "") {
      window.location.href = decodedURL;
    }
  };

  const initialValidationErrors: Record<string, string> = {};
  return (
    <>
      <div className="Return" id="orderProcessed">
        {isLoading ? (
          <Spinner />
        ) : (
          <Container role="main" aria-labelledby="thank-you-page-heading">
            <Row xs={'auto'} md={'auto'}>

                <Col md={"7"} sm={"auto"} className="w100" role="region" aria-labelledby="order-details-heading">
                  <h3 id="order-details-heading" className="visually-hidden">{t('ORDER_DETAILS')}</h3>
                <h2
                  id="thank-you-page-heading"
                  className="pageHeading"
                  dangerouslySetInnerHTML={{ __html: sanitizedSymbol }}
                />

                  <Card id="ShoppingCartMobile">
                    {cartData && (
                      <Cart
                        onCartChange={(e) => { }}
                        validationErrors={initialValidationErrors}
                        onPromoChange={(e) => { }}
                        onPromoSubmit={(e) => { }}
                        onPromoDelete={(e) => { }}
                        isVerify={isVerify}
                        isThanks={isThanks}
                        cartData={cartData}
                        promoCodeError={false}
                      />
                    )}
                  </Card>
                <div className="orderInfo mb-4" role="region" aria-labelledby="order-info-heading">
                  <h3 id="order-info-heading" className="">{t("ORDERINFO01")}</h3>
                  <address>
                    <p className="orderInfoName">
                      <b>{t("ORDER_DATE_COLON")}</b>{" "}
                      <span>{currentDate}</span>
                    </p>
                    <p className="orderNumber">
                      <b>{t("ORDER_NUMBER_COLON")}</b>{" "}
                      <span>{orderNumber}</span>
                    </p>
                    <p className="orderTotal">
                      <b>{t("ORDER_TOTAL_COLON")}</b> <span>{orderTotal}</span>
                      </p>
                    </address>
                </div>
                <div className="orderInstruction mb-4" role="region" aria-labelledby="contact-info-heading">
                  <h3 id="contact-info-heading" className="">{t("DR_CONTACT_INFORMATION_PAGE_TITLE")}</h3>
                  <p>
                    <b>{orderEmail}</b>
                  </p>
                  <p>{t("EMAIL_ORDER_DETAILS")}</p>
                </div>
                  {(<div className="mb-4" role="region" aria-labelledby="shipping-address-heading">
                  <h3 id="shipping-address-heading" className="">{t("SHIPPING_ADDRESS")}</h3>
                  <address>
                    <p className="shippingInfoName">
                      <b>{shippingInfoName}</b>
                    </p>
                    {shippingAttn && (
                      <p className="shippingAttn">
                        <b>{t("ATTN")}:</b> {shippingAttn}
                      </p>
                    )}
                    <p className="shippingAddress">
                      {shippingAddress}
                    </p>
                    <p className="shippingCountry">{shippingCountry}</p>
                      {<span className="shippingContact">{shippingContact}</span>}
                  </address>
                </div>)}

                <div className="orderInstruction orderDisclaimer mb-4" role="region" aria-labelledby="order-instructions-heading">
                  <h3 id="order-instructions-heading" className="">{t("ORDER_INSTRUCTIONS_TITLE")}</h3>
                  <div role="contentinfo" aria-labelledby="order-instructions-heading">
                    <p dangerouslySetInnerHTML={{ __html: sanitizedText }} />
                  </div>
                </div>
              </Col>
                <Col md={"5"} sm={"auto"} className="w100" role="complementary" aria-labelledby="order-summary-heading">
                  <Card id="ShoppingCart" className="reviewOrder">
                  <h3 id="order-summary-heading" className="visually-hidden">{t('ORDER_SUMMARY')}</h3>
                  {cartData && (
                    <Cart
                      onCartChange={(e) => { }}
                      validationErrors={initialValidationErrors}
                      onPromoChange={(e) => { }}
                      onPromoSubmit={(e) => { }}
                        onPromoDelete={(e) => { }}
                      isVerify={isVerify}
                      isThanks={isThanks}
                      cartData={cartData}
                      promoCodeError={false}
                    />
                  )}
                </Card>
              </Col>
              <Col md={6} role="region" aria-labelledby="return-to-store-heading">
                <h3 id="return-to-store-heading" className="visually-hidden">{t('RETURN_TO_STORE')}</h3>
                <Button
                  type="button"
                  variant="success"
                  className="btn-green submitOrder mt-2 return-to-store-btn"
                  onClick={returnStore}
                  aria-label={t('RETURN_TO_STORE')}
                >
                  {t('RETURN_TO_STORE')}
                </Button>
              </Col>
            </Row>
          </Container>
        )}
      </div>
    </>
  );
};

export default ThankYou;